export const URLAPIANALYTICS = 'https://sonarsaludocupacional.com/notis/analytics.php'

export const PROPIEDADNUM = '487144134'

export const MESES = ['Ene', 'Feb', 'Mar', 'Abr', "May", 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

export const TOTALUSUARIOS = 'totalUsers'

export const USUARIOSNUEVOS = 'newUsers'

export const TIEMPOPROMEDIONAVEGACION = 'averageSessionDuration'

export const USUARIOSACTIVOS = 'activeUsers'


export const DIMENCIONORIGEN = 'source'

export const DIMENCIONORIGENCANALES = 'sessionPrimaryChannelGroup'

export const DIMENCIONNOMBREPAGINA = 'pageTitle'






